import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const HospitalSolution = () => {
  return (
    <section id="hospital-solution" className="landing hospital-landing">
      <Helmet>
        <title>Enterprise Hospital ERP for Multi-Specialty Hospitals — Mediway Nextgen</title>
        <meta name="description" content="Comprehensive hospital ERP and HMS software for multi-specialty hospitals in India. Scalable IPD bed management, operation theater (OT), and department routing." />
        <link rel="canonical" href="https://mediwaynextgen.wayug.com/solutions/for-multi-specialty-hospitals" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'SoftwareApplication',
            'name': 'Enterprise Hospital ERP',
            'description': 'Robust, multi-tier Hospital Information System (HIS) with complete IPD, Operation Theater, and LIS systems integrated into one cloud dashboard.',
            'brand': 'Mediway Nextgen',
            'url': 'https://mediwaynextgen.wayug.com/solutions/for-multi-specialty-hospitals',
            'applicationCategory': 'EnterpriseApplication'
          })}
        </script>
      </Helmet>

      <div className="container">
        <header className="section-header">
          <h2 className="section-title">Hospital ERP Software for Multi-Specialty Chains</h2>
          <p className="section-subtitle">An enterprise-grade system that scales from single-facility hospitals to multi-state regional corporate hospital networks.</p>
        </header>

        <div className="service-content">
          <div className="service-header">
            <div className="service-icon">🏢</div>
            <div className="service-info">
              <h3 className="service-title">360° Hospital Governance</h3>
              <p className="service-description">Sync your IPD wards, emergency rooms (ER), clinical staff, LIS labs, imaging departments, and backend billing with centralized cloud reporting.</p>
            </div>
          </div>

          <div className="service-body">
            <div className="service-features">
              <h4>Enterprise Capabilities</h4>
              <ul className="features-list">
                <li className="feature-item"><span className="feature-check">✓</span><span>Live Bed &amp; Ward Occupancy Trackers</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>OT scheduling &amp; anaesthesia charting</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Role-based Access Controls (RBAC)</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Departmental MIS &amp; Profitability Analytics</span></li>
              </ul>
            </div>

            <div className="service-benefits">
              <h4>Enterprise Benefits</h4>
              <div className="benefits-grid">
                <div className="benefit-card"><div className="benefit-icon">🔥</div><span>High-Performance Scaling</span></div>
                <div className="benefit-card"><div className="benefit-icon">🔒</div><span>ISO 27001 Data Guard</span></div>
                <div className="benefit-card"><div className="benefit-icon">📊</div><span>Board-Ready Reports</span></div>
              </div>
            </div>
          </div>

          <div className="service-actions">
            <Link to="/contact" className="btn btn-primary">Book Enterprise Demo</Link>
            <Link to="/services" className="btn btn-secondary">View Modules Suite</Link>
          </div>
        </div>
      </div>

      <div className="services-background">
        <div className="background-pattern"></div>
      </div>
    </section>
  );
};

export default HospitalSolution;
